import { z } from 'zod';
/** MAP-066. The authored planet format. Drawn by hand, fixed as art. */
export const latLonSchema = z.tuple([
    z.number().min(-90).max(90), // lat
    z.number().min(-180).max(180), // lon
]);
export const landmassSchema = z.object({
    /** Stable across art revisions: regions bind to this, never to an index. */
    key: z.string().min(1).max(64),
    name: z.string().min(1).max(80),
    /** Outer ring, counter-clockwise seen from outside, first vertex not repeated. */
    ring: z.array(latLonSchema).min(3).max(4000),
    /** How much fractal detail the coastline synthesiser should add. */
    roughness: z.number().min(0).max(1).default(0.5),
    /** Optional hand-placed label anchor; computed if absent. */
    labelAnchor: latLonSchema.optional(),
});
export const worldArtSchema = z.object({
    format: z.literal('map.world'),
    version: z.number().int().positive(),
    key: z.string().min(1).max(64),
    name: z.string().min(1).max(80),
    /** Drives every seeded decision for this planet, so worlds are reproducible. */
    seed: z.number().int().nonnegative(),
    palette: z
        .object({
        oceanShift: z.number().min(-1).max(1).default(0),
        landShift: z.number().min(-1).max(1).default(0),
    })
        .default({ oceanShift: 0, landShift: 0 }),
    continents: z.array(landmassSchema).min(1).max(32),
    islands: z.array(landmassSchema).max(256).default([]),
});
export function parseWorldArt(input) {
    const parsed = worldArtSchema.safeParse(input);
    if (parsed.success)
        return { art: parsed.data };
    return {
        issues: parsed.error.issues.map((i) => ({ path: i.path.join('.'), message: i.message })),
    };
}
//# sourceMappingURL=format.js.map